import { getSparkflowGlobalContext, MilestoneAgentName, MilestoneStatus, } from '@thoughtspot/blink-context';
import { Image } from '@thoughtspot/radiant-react/widgets/image';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize, ModalType, } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import { create as createLogger } from '../../utils/logger';
import { getMilestoneConfig, MILESTONE_CHECKMARK_SRC, SPARKFLOW_TEST_IDS, } from '../../utils/sparkflow-constants';
import styles from './milestone-modal.module.scss';
const logger = createLogger('milestone-modal');
export const MilestoneModal = ({ onDismiss, onPrimaryCtaClick, onSecondaryCtaClick, onTertiaryCtaClick, }) => {
    const { milestone } = getSparkflowGlobalContext();
    const { isModalOpen, agentName, status } = milestone;
    if (!isModalOpen) {
        return null;
    }
    if (agentName === MilestoneAgentName.NONE) {
        logger.error('Milestone agent name is not set');
        return null;
    }
    if (status === MilestoneStatus.NONE) {
        logger.error('Milestone status is not set', { agentName });
        return null;
    }
    const statusConfig = getMilestoneConfig(agentName, status);
    if (!statusConfig) {
        logger.error('No status config found for milestone modal', {
            agentName,
            status,
        });
        return null;
    }
    const modalHeader = (React.createElement(Horizontal, { vAlignContent: "center", spacing: "c" },
        React.createElement(Image, { src: MILESTONE_CHECKMARK_SRC, className: styles.milestoneIcon }),
        React.createElement(Typography, { variant: "h3", noMargin: true, className: styles.title }, statusConfig.title)));
    return (React.createElement(Modal, { isOpen: true, customPortalClassName: styles.milestoneModalWrapper, size: ModalSize.MEDIUM3, variant: ModalType.NoAlert, modalTestId: SPARKFLOW_TEST_IDS.MILESTONE_MODAL, title: modalHeader, onDismiss: onDismiss, contentClassName: cx(styles.modalBodyWrapper, styles[statusConfig.bgImageClassName]), confirmButton: statusConfig.primaryCta
            ? {
                text: statusConfig.primaryCta,
                onConfirm: onPrimaryCtaClick,
            }
            : undefined, dismissButton: statusConfig.secondaryCta
            ? {
                text: statusConfig.secondaryCta,
                onClick: onSecondaryCtaClick,
            }
            : undefined, denyButton: statusConfig.tertiaryCta
            ? {
                text: statusConfig.tertiaryCta,
                onDeny: onTertiaryCtaClick,
            }
            : undefined },
        React.createElement(Vertical, { vAlignContent: "center", hAlignContent: "center" },
            React.createElement(Typography, { variant: "p-large", noMargin: true, className: styles.subtitle }, statusConfig.subtitle))));
};
//# sourceMappingURL=milestone-modal.js.map